// src/utils/analytics/track.js
export function trackEvent(name, params = {}) {
  if (typeof window.gtag !== "function") return; // no consent / not loaded
  window.gtag("event", name, params);
}

export function trackPageView(path) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_location: window.location.href,
    page_path: path,
  });
}

export const analytics = {
  trackEvent,
  trackPageView,
};
